import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { getCertificateAsync } from '../../../Services/CertificateService';
import jsPDF from 'jspdf';
import moment from 'moment';
import TSALogo from '../../../Assets/TSALogo.png';
import Signature from '../../../Assets/signature.png';

// Generates the course completion certificate as a PDF in the browser. :id is the learner-course
// (tracking) id; the certificate is only available once the course is complete.
const Certificate = () => {

    const { id } = useParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        const print = async () => {
            const certificate = await getCertificateAsync(id);
            if (!certificate) {
                setError("There's no certificate for this course yet - it's available once the course is complete.");
                return;
            }

            const learnerName = `${certificate.firstName || ''} ${certificate.lastName || ''}`.trim();
            const title = certificate.courseTitle || '';
            const completedDate = moment(certificate.completedDate).format("D MMMM YYYY");

            const pdf = new jsPDF("p", "mm", "a4");
            pdf.addImage(TSALogo, 'JPEG', 20, 20, 130, 40);

            pdf.setTextColor(60, 60, 60);
            pdf.setFontSize(22);
            pdf.text('CERTIFICATE OF COMPLETION', 20, 90, 'left');

            pdf.setFontSize(18);
            pdf.text('This is to certify that', 20, 108, 'left');

            pdf.setFontSize(23);
            pdf.setTextColor(60, 60, 60);
            let splitLearner = pdf.splitTextToSize(learnerName, 150);
            pdf.text(20, 128, splitLearner, 'left');

            pdf.setFontSize(18);
            pdf.setTextColor(113, 113, 113);
            pdf.text('has successfully completed', 20, 145, 'left')

            pdf.setFontSize(25);
            pdf.setTextColor(60, 60, 60);
            let splitCourseTitle = pdf.splitTextToSize(title, 150);
            pdf.text(20, 168, splitCourseTitle, 'left');

            pdf.setFontSize(14);
            pdf.setTextColor(113, 113, 113);
            pdf.text(`on ${completedDate}`, 20, 168 + splitCourseTitle.length * 11, 'left');

            pdf.addImage(TSALogo, 'JPEG', 25, 214, 60, 20);
            pdf.addImage(Signature, 'JPEG', 30, 234, 50, 16);

            pdf.save(`${learnerName} ${title}.pdf`);
        };

        print().catch(err => {
            console.error(err);
            setError("Your certificate couldn't be created. Please try again, and contact support if it keeps happening.");
        });
    }, [id]);

    return (
        <div className="container-fluid content">
            <div className="row p-5 mt-5">
                <div className="col-12 text-center p-5">
                    {error ? (
                        <h1>{error}</h1>
                    ) : (
                        <>
                            <div className="spinner-border mb-5" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <h1>Please wait while your certificate downloads</h1>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Certificate;
